export * from './simple-layout.component';



// WEBPACK FOOTER //
// ./src/app/containers/simple-layout/index.ts